import React from "react";
import { motion } from "framer-motion";

/* Fade-up on scroll into view */
export const FadeUp = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line reveal for headlines.
   lines: array of strings. Each line sits in an overflow-hidden wrapper. */
export const MaskText = ({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.1 }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "115%" },
    show: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
  };
  return (
    <motion.span variants={container} initial="hidden" animate="show" className={className}>
      {lines.map((l, i) => (
        <span key={i} className="line-mask">
          <motion.span variants={line} className={`block ${lineClassName}`}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
